import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<any, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/custom/generate`,
      method: 'POST',
      body: body.body,
    }),
  });

interface Body {
  tournamentId: number;
  body: FormData;
}
